import React from 'react';

const UserMoney = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.3922 8.73322C17.1449 7.28973 16.4803 5.95025 15.4805 4.88006C14.4808 3.80987 13.1895 3.05581 11.7662 2.71093C10.3428 2.36604 8.84967 2.44543 7.47092 2.93928C6.09216 3.43314 4.88817 4.31986 4.0075 5.49002C3.12683 6.66018 2.60803 8.06258 2.51511 9.52416C2.4222 10.9857 2.75923 12.4425 3.48462 13.7148C4.21002 14.9871 5.29203 16.0191 6.59714 16.6836C7.90225 17.3481 9.37335 17.6159 10.8289 17.4541M7.50058 8.33322H7.50892M12.5006 8.33322H12.5089M7.91725 12.4999C8.46558 13.0332 9.21725 13.3332 10.0006 13.3332C10.2981 13.3332 10.5914 13.2899 10.8698 13.2074M17.5006 12.4999H15.4173C15.0857 12.4999 14.7678 12.6316 14.5334 12.866C14.2989 13.1004 14.1673 13.4184 14.1673 13.7499C14.1673 14.0814 14.2989 14.3994 14.5334 14.6338C14.7678 14.8682 15.0857 14.9999 15.4173 14.9999H16.2506C16.5821 14.9999 16.9 15.1316 17.1345 15.366C17.3689 15.6004 17.5006 15.9184 17.5006 16.2499C17.5006 16.5814 17.3689 16.8994 17.1345 17.1338C16.9 17.3682 16.5821 17.4999 16.2506 17.4999H14.1673M15.8339 17.4999V18.3332M15.8339 11.6666V12.4999",
      stroke: "white",
      strokeOpacity: "0.6",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
UserMoney.displayName = "Icons.UserMoney";

export { UserMoney };
//# sourceMappingURL=UserMoney.js.map
